import { h } from '@atomify/jsx';

const ButtonLoader = () => <span class="c-button-loader" />;

export { ButtonLoader };
